/**
 * Instructions shown for new studies - guides user through creating a Bible study.
 */

export function StudyInstructions() {
  const steps = [
    {
      num: '1',
      color: 'cyan',
      title: 'Choose the passage',
      detail: 'Usually a chapter, but can be more or less. Teaching is verse-by-verse, expositional.',
    },
    {
      num: '2',
      color: 'cyan',
      title: 'Study ahead',
      detail: 'Let the Holy Spirit teach YOU first.',
    },
    {
      num: '3',
      color: 'cyan',
      title: 'Break into scenes',
      detail: 'Digestible segments. Kids draw, adults take notes.',
    },
    {
      num: '4',
      color: 'cyan',
      title: 'Assign readings',
      detail: 'Every student reads aloud, no one is too young.',
    },
    {
      num: '5',
      color: 'cyan',
      title: 'Ask questions',
      detail: "Tailored to each student's age and experience.",
    },
  ];

  return (
    <div className="space-y-4 text-stone-600 dark:text-stone-400">
      <h3 className="text-lg font-semibold text-stone-800 dark:text-stone-200">
        Creating a Bible Study
      </h3>

      <ol className="space-y-3 text-sm">
        {steps.map((step) => (
          <li key={step.num} className="flex gap-2">
            <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-cyan-100 text-xs font-medium text-cyan-700 dark:bg-cyan-900/50 dark:text-cyan-300">
              {step.num}
            </span>
            <span>
              <strong>{step.title}</strong> — {step.detail}
            </span>
          </li>
        ))}
        <li className="flex gap-2">
          <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-xs font-medium text-amber-700 dark:bg-amber-900/50 dark:text-amber-300">
            !
          </span>
          <span>
            <strong>PRAY before you start!</strong>
          </span>
        </li>
      </ol>

      <div className="border-t border-stone-200/50 pt-4 dark:border-stone-700/50">
        <p className="text-sm text-stone-500 dark:text-stone-400">
          To begin, drag a verse label from the Bible text below into the Starting Verse area.
        </p>
      </div>
    </div>
  );
}
